import { render, staticRenderFns } from "./PlanHome.vue?vue&type=template&id=3b6cd43e"
import script from "./PlanHome.vue?vue&type=script&lang=js"
export * from "./PlanHome.vue?vue&type=script&lang=js"
import style0 from "./PlanHome.vue?vue&type=style&index=0&id=3b6cd43e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports